export const getAuthorText = author => {
  return `By ${author}`
}

export const getIllustratorText = illustrator => {
  return `Illustrated by ${illustrator}`
}
